<template>
    <div class="Personalcenter">
        <div class="cen_Top">
            <div class="_T_header">
                <span>个人资料</span>
            </div>
            <div class="_T_content">
                <div class="_T_portrait" v-preventReClick @click="dialogVisible=true">
                    <img :src="imageUrl===null||imageUrl===''||imageUrl==='null'?'https://static.ibeisai.com/image/default_avatar.png':imageUrl" alt="">
                </div>
                <div class="_T_phone">
                   <span>用户名：{{userName}}</span> 
                   <span class="margin10">
                       <i class="iconfonts icons-xiugai" v-preventReClick @click="updatN()"></i>
                   </span>
                </div>
                <div class="_T_phone">
                    手机号：<span>{{phone}}</span>
                    <!-- <span class="margin10">
                       <i class="iconfonts icons-xiugai"></i>
                   </span> -->
                </div>
                <div class="_T_phone">
                    登录密码：*********
                    <span class="margin10">
                       <i class="iconfonts icons-xiugai" v-preventReClick @click="psword()"></i>
                   </span>
                </div>
            </div>
        </div>
        <div class="cen_Bottom">
            <div class="_T_header">
                <span>课程信息</span>
            </div>
            <ul class="_B_ul clearfix">
                <li class="fl" v-for="(item,index) in TeamList" :key="index" v-preventReClick @click="liBox(item)">
                    <div class="_li_tile">
                        <span>{{item.name}}</span>
                        <div class="_li_tile_div" :ref="'ckmain' + index">
                            <i class="el-icon-more" v-preventReClick @click.stop="ckBox(index,item)"></i>
                            <transition name="ckfade">
                                <ul class="_div_ck" v-if="item.ckTrue == true" @click.stop="oBox()">
                                    <li v-preventReClick @click.stop="panelBox(item)">
                                        <span>更换小组</span>
                                    </li>
                                    <li v-preventReClick @click.stop="feedBack(item)">用户反馈</li>
                                    <li v-preventReClick @click.stop="deletBox(item)">
                                        <span>删除</span>
                                    </li>
                                </ul>
                            </transition>
                        </div>
                    </div>
                    <img class="_li_imgs" src="./../../assets/img/line_2.png" alt="">
                    <div class="_li_divs">
                        <div class="_li_d_one clearfix">
                            <span class="fl"> 
                                课程码：{{item.code}}
                            </span>
                            <span class="fr _li_d_span" :class="item.state==1?'_d_dks':item.state==2?'_d_jxz':'_d_yjs'">
                                {{item.state==1?'待开始':item.state==2?'进行中':'已结束'}}
                            </span>
                        </div>
                        <div class="_li_d_time">
                            <span>开课时间：{{item.start}} - {{item.end}}</span>
                        </div>
                        <div class="_li_d_one clearfix">
                            <span class="fl _d_one_sopan">
                                课程类别：A场
                            </span>
                            <span class="fl _d_one_sopan">
                                主讲老师：{{item.teacherName}}
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 弹窗 -->
        <div class="Usern_Popup">
            <el-dialog
                title="修改用户名"
                :visible.sync="dialogusername"
                :show-close="false"
                width="400px"
                :before-close="handleClose"
            >
                <i class="el-icon-close closei"  @click="closei('ruleForm')"></i>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" @submit.native.prevent>
                    <el-form-item  prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入新的用户名"  @keyup.enter.native="enterInput($event,'ruleForm')"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" v-preventReClick @click="closei('ruleForm')">取消</el-button>
                    <el-button type="primary" size="small" v-preventReClick @click="rolexit('ruleForm')">确定</el-button>
                </span>
            </el-dialog>
            <el-dialog
                title="修改密码"
                :visible.sync="dialoguserpassword"
                :show-close="false"
                width="400px"
                :before-close="handleClose"
            >
                <i class="el-icon-close closei" v-preventReClick @click="closei('wordForm')"></i>
                <el-form :model="wordForm" ref="wordForm" :rules="rules" class="demo-ruleForm" @submit.native.prevent>
                    <el-form-item  prop="oldpw">
                        <el-input v-model="wordForm.oldpw" type="password" placeholder="请输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item  prop="newpw">
                        <el-input v-model="wordForm.newpw" type="password" placeholder="确认密码"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" v-preventReClick @click="closei('wordForm')">取消</el-button>
                    <el-button type="primary" size="small" v-preventReClick @click="roleadd('wordForm')">确定</el-button>
                </span>
            </el-dialog>
        </div>
        <!-- 弹窗 -->
        <div class="sroom_Popup">
            <el-dialog
                title="更换小组"
                :visible.sync="dialogVisibleForm"
                :show-close="false"
                width="450px"
                :before-close="handleClose"
            >
                <i class="el-icon-close closei" v-preventReClick @click="closei('Form')"></i>
                <el-form :model="Form" :rules="rules" ref="Form" class="demo-ruleForm" @submit.native.prevent>
                    <el-form-item label="课程名称：" prop="name">
                        <el-input v-model="Form.name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="课堂码：">
                        <el-input v-model="Form.code" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="选择小组：" prop="teamName">
                        <el-select v-model="Form.teamName" placeholder="请选择要加入的组">
                            <el-option
                                v-for="(item,index) in listTeam"
                                :key="index"
                                :label='item.name'
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" v-preventReClick @click="closei('Form')">取 消</el-button>
                    <el-button size="small" type="primary" v-preventReClick @click="deter('Form')">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="member_Popup">
            <el-dialog
                title="编辑头像"
                :visible.sync="dialogVisible"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="600px"
            >
                <div style="display: flex" class="avatar">
                <div class="avatar-left">
                    <div v-show="!options.img">
                        <el-upload
                            ref="upload"
                            :action="uploads"
                            style="text-align: center;margin-bottom: 24px"
                            :on-change="uploadsipaate"
                            accept="image/png, image/jpeg, image/jpg"
                            :show-file-list="false"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary" ref="uploadBtn">选择图片</el-button>
                        </el-upload>
                    <div>支持jpg、png格式的图片，大小不超过3M</div>
                    </div>
                    <div v-show="options.img" class="avatar-left-crop">
                        <vueCropper
                            class="crop-box"
                            ref="cropper"
                            :img="options.img"
                            :autoCrop="options.autoCrop"
                            :canScale="options.canScale"
                            :fixedBox="options.fixedBox"
                            :canMoveBox="options.canMoveBox"
                            :autoCropWidth="options.autoCropWidth"
                            :autoCropHeight="options.autoCropHeight"
                            :centerBox="options.centerBox"
                            @realTime="realTime">
                        </vueCropper>
                        <p class="avatar-left-p">鼠标滚轮缩放控制图片显示大小，鼠标拖拽调整显示位置</p>
                    </div>
                </div>
                <div class="avatar-right">
                    <div class="avatar-right-div" v-for="(item,index) in previewsDiv" :key="index" :style="item.style">
                    <div v-show="options.img" :class="previews.div" class="avatar-right-previews" :style="item.zoomStyle">
                        <img :src="previews.url" :style="previews.img">
                    </div>
                    </div>
                    <div class="avatar-right-text">
                    <el-button v-if="options.img" type="text" v-preventReClick @click="uploadPreviews">重新上传</el-button>
                    <span v-else>预览</span>
                    </div>
                </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button v-preventReClick @click="closeDialog()">取 消</el-button>
                    <el-button type="primary" v-preventReClick @click="getCrop">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    punliceFilters:{
        mobileFilter(val){
            let reg = /^(.{3}).*(.{4})$/
            return val.replace(reg,'$1****$2')
        }
    },
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.wordForm.newpw !== '') {
                    this.$refs.wordForm.validateField('newpw');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.wordForm.oldpw) {
                callback(new Error('🙄 两次输入的密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            listTeam:[],
            Form:{
                code:''
            },
            rules:{
                name:[
                    { required: true, message: '请输入用户名', trigger:'blur'},
                ],
                teamName:[
                    { required: true, message: '请选择小组', trigger:'change'},
                ],
                oldpw: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                newpw: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
            },
            num:0,
            ckTrue:false,
            imageUrl:'',
            userName:'',
            phone:'',
            TeamList:[],
            uploads:'',
            dialogVisibleForm:false,
            dialogusername:false,
            dialogVisible:false,
            dialoguserpassword:false,
            form:{
                phone:''
            },
            wordForm:{
                oldpw:'',
                newpw:'',
            },
            ruleForm:{
                name:'',
            },
            options: {
                img: '',  //原图文件
                autoCrop: true,  //默认生成截图框
                fixedBox: true,  //固定截图框大小
                canMoveBox: false,    //截图框不能拖动
                autoCropWidth: 200,  //截图框宽度
                autoCropHeight: 200, //截图框高度
                centerBox: true,    //截图框被限制在图片里面
                canScale: true, //图片是否允许滚轮缩放
            },
            //实时预览图数据
            previews: {},
            previewsDiv: [
                //108px 预览样式
                {
                    style: {
                    width: '108px',
                    height: '108px',
                    margin: '0 auto'
                    },
                    zoomStyle: {
                        transform:'scale(0.54,0.54)',
                        transformOrigin:'top left',
                    }
                },
                //68px 预览样式
                {
                    style: {
                    width: '68px',
                    height: '68px',
                    margin: '27px auto'
                    },
                    zoomStyle: {
                        transform:'scale(0.34,0.34)',
                        transformOrigin:'top left',
                    }
                },
                //48px 预览样式
                {
                    style: {
                    width: '48px',
                    height: '48px',
                    margin: '0 auto'
                    },
                    zoomStyle: {
                        transform:'scale(0.24,0.24)',
                        transformOrigin:'top left',
                    }
                }
            ],
        }
    },
    methods: {
        getapp(){
            this.uploads = this.$store.state.uploads
            this.imageUrl = this.$store.state.user_avatar
            this.userName = this.$store.state.user_name
            this.phone = this.$store.state.phone
            this.axios.StuCourseList({
                token:this.$store.state.token,
                state:0,
                year:0,
                search:'',
            }).then(res=>{
                if(res.data.code==0){
                    var arr = []
                    res.data.data.forEach(item=>{
                        arr.push(
                            Object.assign({},item,{ckTrue:false})
                        )
                    })
                    this.TeamList = arr
                }
            }).catch(err=>{

            })
        },
        // 跳转详情首页
        liBox(item){
            this.$store.dispatch("cla_id",item.id)
            this.$router.push({name:'StudentPage'})
        },
        oBox(){

        },
        //更换小组
        panelBox(item){
            if(item.state==1){
                this.axios.StuCourseteam({
                    token:this.$store.state.token,
                    id:item.id
                }).then(res=>{
                    if(res.data.code==0){
                        this.listTeam = res.data.data
                        this.dialogVisibleForm = true
                        this.Form = item
                    }else{
                        this.$message.error(res.data.message)
                    }
                }).catch(err=>{

                })
            }else{
                this.$message.warning('课堂已开课，无法更换小组')
            }
            item.ckTrue = false
        },
        deter(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.listTeam.map(item=>{
                        if(this.Form.teamName==item.name){
                            this.id = item.id
                        }
                    })
                    this.axios.StuCoursswitchTeam({
                        token:this.$store.state.token,
                        cId:this.Form.id,
                        id:this.id
                    }).then(res=>{
                        if(res.data.code==0){
                            this.$message.success('更换小组成功')
                            this.dialogVisibleForm = false
                            this.$refs[formName].resetFields();
                            this.getapp()
                        }else{
                            this.$message.error(res.data.message)
                        }
                    }).catch(err=>{

                    })
                }
            })
        },
        // 用户反馈
        feedBack(item){
            if(item.state==3){
                 this.$router.push({name:'Userfeedback',query:{
                    cla_id:item.id
                }})
            }else{
                this.$message.error('课程未结课，无法进行反馈！')
            }
            
        },
        //删除课程
        deletBox(item){
            this.$confirm('此操作永久删除该记录，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal:false
            }).then(() => {
                this.axios.witchDel({
                    token:this.$store.state.token,
                    id:item.id
                }).then(res=>{
                    if(res.data.code==0){
                        this.$message.success('删除成功')
                        this.getapp()
                    }else{
                        this.$message.error(res.data.message)
                    }
                }).catch(err=>{

                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        ckBox(val,item){
            this.TeamList.filter(el=>{
                if(el.code==item.code && item.ckTrue==false){
                    el.ckTrue = true
                }else{
                    el.ckTrue = false
                }
            })
            this.num = val
        },
        //修改用户名
        rolexit(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios.userupdate({
                        token:this.$store.state.token,
                        name:this.ruleForm.name,
                        avatar:this.$store.state.user_avatar
                    }).then(res=>{
                        if(res.data.code==0){
                            this.$store.dispatch("user_name",res.data.data.user_name)
                            this.dialogusername = false
                            this.getapp()
                        }else{
                            this.$message.info(res.data.message)
                        }
                    }).catch(err=>{

                    })
                }
            })
        },
        roleadd(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios.changepw({
                        token:this.$store.state.token,
                        oldpw:this.wordForm.oldpw,
                        newpw:this.wordForm.newpw
                    }).then(res=>{
                        if(res.data.code==0){
                            this.$message.success('密码修改成功')
                            this.dialoguserpassword = false
                            this.getapp()
                        }else{
                            this.$message.error(res.data.message)
                        }
                    }).catch(err=>{

                    })
                }
            })
        },
        // 输入框回车事件
        enterInput(e,val){
            if (e.which == 13 || e.charCode == 13 || e.keyCode == 13) {
                this.rolexit(val);
            }
        },
        updatN(){
            this.ruleForm.name = this.userName
            this.dialogusername = true
        },
        psword(){
            this.dialoguserpassword = true
        },
         //重新上传
        uploadPreviews() {
            this.$refs.uploadBtn.$el.click()
        },
        //实时预览数据
        realTime(data) {
            this.previews = data
        },
        //获取截图信息
        getCrop() {
            // 获取截图的 base64 数据
            let formData = new FormData();
            this.$refs.cropper.getCropBlob((data) => {
                formData.append("file", data,this.fileName);
                axios.post(this.uploads,formData).then(res=>{
                    if(res.data.code==0){
                        this.axios.userupdate({
                            token:this.$store.state.token,
                            avatar:res.data.data,
                            name:this.$store.state.user_name
                        }).then(res=>{
                            if(res.data.code==0){
                                this.$store.dispatch("user_avatar",res.data.data.user_avatar)
                                this.dialogVisible = false
                                this.getapp()
                            }
                        }).catch(err=>{

                        })
                    }
                }).catch(err=>{

                })
                // this.imageUrl = data
                // this.dialogVisible = false
            })
        },
        //关闭弹框
        closeDialog() {
            this.dialogVisible = false
            //重置 data 数据。(Object.assign是对象深复制  this.$data是组件内的数据对象 this.$options.data()是原始的数据)
            Object.assign(this.$data, this.$options.data())
            // this.imageUrl = this.$store.state.user_avatar
            this.getapp()
        },
         //读取原图
        uploadsipaate(file) {
            const isIMAGE = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
            const isLt3M = file.raw.size / 1024 / 1024 < 3;
            if (!isIMAGE) {
                this.$message({
                    showClose: true,
                    message: '请选择 jpg、png 格式的图片！',
                    type: 'error',  //提示类型
                });
                return false;
            }
            if (!isLt3M) {
                this.$message({
                    showClose: true,
                    message: '上传图片大小不能超过 3MB',
                    type: 'error',  //提示类型
                });
                return false;
            }
            let data = window.URL.createObjectURL(new Blob([file.raw]));
            this.fileName = file.name
            this.options.img = data;
        },
        handleClose(done){

        },
        closei(){
            this.dialogVisibleForm = false
            this.dialogusername = false
            this.dialoguserpassword = false
        },
        bodyC(e){
            let name = 'ckmain' + this.num
            if (this.$refs[name][0] && !this.$refs[name][0].contains(e.target)) {
                if (this.TeamList[this.num].ckTrue == true){
                    this.TeamList[this.num].ckTrue = false;
                }
            }
        },
    },
    mounted() {
        this.getapp()
        // setTimeout(function(){
            document.addEventListener("click", this.bodyC);
        // },1000)
    },
    beforeDestroy() {
        document.removeEventListener("click", this.bodyC);
    },
}
</script>
<style scoped>
@import './../../assets/css/student/Personalcenter.css';
</style>
<style>
.sroom_Popup .el-dialog__header{
    padding: 10px 20px;
}
.sroom_Popup .el-dialog{
    border-radius: 6px;
    background: rgba(25, 36, 105, 1);
    border: 1px solid #34FFFF;
}
.sroom_Popup .el-dialog__title{
    font-size: 16px;
    color: #fff;
}
.sroom_Popup .el-dialog__body{
    padding: 20px 40px 10px;
}
.sroom_Popup .el-dialog__footer{
    text-align: center;
}
.sroom_Popup .el-form-item{
    margin-bottom:10px;
}
.sroom_Popup .el-button--small{
    width: 100px;
    height: 32px;
    font-size: 14px;
    line-height: 32px;
    padding: 0;
}
.sroom_Popup .el-select{
    width: 100%;
}
.sroom_Popup .el-form-item__label{
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
}
.ckfade-enter,.ckfade-leave-to{
    opacity: 0;
    transform: translateY(-15px);
}
.ckfade-enter-active,.ckfade-leave-active{
    transition: 0.3s cubic-bezier(0.25,0.8,0.5,1)!important;
}
.Usern_Popup .el-dialog__title{
    font-size: 16px;
    color: #fff;
}
.Usern_Popup .el-dialog__body{
    padding: 20px 30px 10px;
}
.Usern_Popup .el-dialog__header{
    padding: 10px 20px;
}
.Usern_Popup .el-dialog{
    border-radius: 6px;
    background: rgba(25, 36, 105, 1);
    border: 1px solid #34FFFF;
}
.Usern_Popup .el-dialog__footer{
    text-align: center;
}
.Usern_Popup .el-button--small{
    width: 100px;
    height: 32px;
    font-size: 14px;
    line-height: 32px;
    padding: 0;
}
/* 编辑头像 */
.member_Popup .el-dialog__header {
    padding: 24px 0 11px 28px;
}
.member_Popup .el-dialog__title {
    color: #333333;
}
.member_Popup .el-dialog__body {
    padding: 0 28px;
}
.member_Popup .el-dialog__footer {
    padding: 20px 28px;
}
.member_Popup .el-button {
    width: 110px;
}
.member_Popup .avatar {
    display: flex;
}
.member_Popup .avatar-left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 400px;
      height: 400px;
      background-color: #F0F2F5;
      margin-right: 10px;
      border-radius: 4px;
}
.member_Popup .avatar-left-crop {
    width: 400px;
    height: 400px;
    position: relative;
}
.member_Popup .crop-box {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    overflow: hidden
}
.member_Popup .avatar-left-p {
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 20px;
    color: #ffffff;
    font-size: 14px;
}
.member_Popup .avatar-right {
      width: 150px;
      height: 400px;
      background-color: #F0F2F5;
      border-radius: 4px;
      padding: 16px 0;
      box-sizing: border-box;
}
.member_Popup .avatar-right-div {
    border: 3px solid #ffffff;
    border-radius: 50%;
    }

.member_Popup .avatar-right-previews {
    width: 200px;
    height: 200px;
    overflow: hidden;
    border-radius: 50%;
}
.member_Popup .avatar-right-text {
    text-align: center;
    margin-top: 50px;
    font-size: 14px;
}
.member_Popup .avatar-right-text span {
    color: #666666;
}
</style>